import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M3.227 8c-.672 0-1.345-.667-1.345-1.333 0-.667.673-1.334 1.345-1.334S4.57 6 4.57 6.667C4.571 7.333 3.9 8 3.227 8m2.689-3.6c-.672 0-1.345-.667-1.345-1.333 0-.667.673-1.334 1.345-1.334s1.345.667 1.345 1.334c0 .666-.673 1.333-1.345 1.333m4.437 0c-.672 0-1.345-.667-1.345-1.333 0-.667.673-1.334 1.345-1.334s1.344.667 1.344 1.334c0 .666-.672 1.333-1.344 1.333M13.042 8c-.672 0-1.345-.667-1.345-1.333 0-.667.673-1.334 1.345-1.334s1.345.667 1.345 1.334c0 .666-.673 1.333-1.345 1.333M8.067 0C3.63 0 0 3.6 0 8s3.63 8 8.067 8c1.076 0 1.748-1.467.941-2.267-.134-.266-.403-.533-.403-.933 0-1.6 1.882-1.333 2.958-1.333 2.555 0 4.437-2 4.437-4.4C16 3.2 12.37 0 7.933 0z"
    }, null, -1)
  ]))]))
}
export default { render: render }